import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Spinner, Col, UncontrolledCollapse } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import useApi from 'hooks/useApi';
import { selectCurrentClient } from 'redux/actions/clientActions';
import { setCollapseNotify, setShowTypeNotifications } from 'redux/actions/notificationActions';

import { ReactComponent as SearchIcon } from 'assets/icon-search.svg';
import { ReactComponent as AngleArrowLeftIcon } from 'assets/icon-angle-left.svg';
import { ReactComponent as CaretDownIcon } from 'assets/icon-angle-down.svg';
import { ReactComponent as CaretUpIcon } from 'assets/icon-angle-up.svg';

import { colors } from 'shared/defaultTheme';

import { SearchDiv, SerachClients, Hr, SerachClientsForm, Ul, CollapseClient } from '../styles';
import { Div, Li, Individual, Massive } from './styles';

const Clients = () => {
  const { customAreaApi } = useApi();
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme);
  const auth = useSelector((state) => state.auth);
  const { currentClient } = useSelector((state) => state.clientState);
  const { showTypeNotifications } = useSelector((state) => state.notification);
  const [searchValue, setSearchValue] = useState('');
  const { t } = useTranslation();
  const { mainColor } = theme;
  const [clientList, setClientList] = useState([]);
  const [individualIsOpen, setIndividualIsOpen] = useState(false);

  const [{ loading }, getClientsData] = customAreaApi(
    {
      url: `${window.API_V1}/cli/clients/${auth.cusNavId}/search`,
      method: 'POST',
    },
    { manual: true }
  );

  const clientsData = async () => {
    const {
      data: { data },
    } = await getClientsData({
      data: {
        filters: [
          {
            model: 'Client',
            field: 'ClientId',
          },
        ],
        reduce: {
          limit: 0,
          skip: 0,
        },
      },
    });
    setClientList(data);
    dispatch(selectCurrentClient(currentClient || data[0]));
  };

  useEffect(() => {
    clientsData();
  }, []);

  const searchClients = async (e) => {
    if (e) {
      const { value } = e.target;
      setSearchValue(value);
      try {
        const {
          data: { data },
        } = await getClientsData({
          data: {
            filters: [
              {
                model: 'Client',
                field: 'ClientName',
                filter: [value],
                isRegex: true,
              },
            ],
            reduce: {
              limit: 0,
              skip: 0,
            },
          },
        });
        setClientList(data);
      } catch (error) {
        setClientList([]);
      }
    } else {
      setSearchValue('');
      try {
        const {
          data: { data },
        } = await getClientsData({
          data: {
            filters: [
              {
                model: 'Client',
                field: 'ClientName',
                filter: [''],
                isRegex: true,
              },
            ],
            reduce: {
              limit: 0,
              skip: 0,
            },
          },
        });
        setClientList(data);
      } catch (error) {
        setClientList([]);
      }
    }
  };

  const onSelectClient = (client) => {
    dispatch(selectCurrentClient(client));
  };

  return (
    <div>
      <SearchDiv className="d-flex">
        <Col>
          <SerachClientsForm className="form">
            <SerachClients
              Icon={() => null}
              borderRadius={2}
              className="mb-4 w-25 m-0 h-50"
              inputClassName="w-100"
              buttonClassName=""
              withButtonClear
              rightIcon={<SearchIcon fill={colors.black} />}
              onChange={searchClients}
              value={searchValue ?? ''}
              placeholder={t('home_search_client')}
            />
          </SerachClientsForm>
        </Col>
        <CollapseClient onClick={() => dispatch(setCollapseNotify(true))}>
          <AngleArrowLeftIcon />
        </CollapseClient>
      </SearchDiv>
      <Hr />
      <Massive
        onClick={() => {
          dispatch(setShowTypeNotifications(true));
        }}
        showTypeNotifications={showTypeNotifications}
      >
        <span>{t('notifications_text_massive')}</span>
      </Massive>
      <Individual
        id="individual-toggler"
        onClick={() => {
          setIndividualIsOpen(!individualIsOpen);
          dispatch(setShowTypeNotifications(false));
        }}
        showTypeNotifications={showTypeNotifications}
      >
        <span>{t('notifications_text_individual')}</span>
        {individualIsOpen ? (
          <CaretUpIcon className="caret" width={15} />
        ) : (
          <CaretDownIcon className="caret" width={15} />
        )}
      </Individual>
      <UncontrolledCollapse toggler="#individual-toggler">
        <Ul className="list-unstyled mt-2">
          {!loading ? (
            <>
              {clientList.map((client) => (
                <Li
                  key={client.clientId}
                  onClick={() => onSelectClient(client)}
                  selectedColor={
                    currentClient?.clientId === client.clientId ? colors.whiteSmoke : colors.white
                  }
                >
                  <Div>{client.clientName}</Div>
                </Li>
              ))}
            </>
          ) : (
            <div className="d-flex justify-content-center mb-5 align-items-center h-100">
              <Spinner color={mainColor} />
            </div>
          )}
        </Ul>
      </UncontrolledCollapse>
    </div>
  );
};

Clients.propTypes = {};

export default Clients;
